export const humachLogo =
  "https://lh3.googleusercontent.com/RkKRbDEwyvyFMLwEXNoQ3NzdzdMmw0l-lXno6Ip8zPvH3sot4LTsyTRg8PwFxtz7MMJbuMMVYaEVTbdhpFzHSfUcV2CTg-nCvOzK1w=s120";
